import React from 'react';
function Arroz() {
    return (
      <div>
       <h1>Recetas de Arroz</h1>
      </div>
    );
  }
  
  export default Arroz;